import React, { memo } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton, Snackbar, SnackbarContent, SnackbarProps } from '@mui/material';
import { useTranslation } from 'i18n';

interface IProps extends SnackbarProps {
  messageKey?: string;
}

const defaultMessageKey = 'common:message.urlCopied';

const CopyUrlSnackbar: React.FC<React.PropsWithChildren<IProps>> = ({
  messageKey = defaultMessageKey,
  onClose,
  ...props
}) => {
  const [t] = useTranslation();

  const handleCloseClick: React.MouseEventHandler = (e) => {
    onClose(e, 'timeout');
  };

  return (
    <Snackbar {...props} autoHideDuration={3000} onClose={onClose}>
      <SnackbarContent
        message={t(messageKey)}
        action={
          <IconButton size="small" color="inherit" onClick={handleCloseClick}>
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      />
    </Snackbar>
  );
};

export default memo(CopyUrlSnackbar);
